import gql from 'graphql-tag';

export default gql`
	mutation setLogic($questionId: ID!, $data: [logicRulesInput]!) {
		setLogic(questionId: $questionId, data: $data)
	}
`;
